import { commonSelectors } from "../selector-template-generator";

export const trainersConfig = {
  fields: [
    {
      name: "email",
      label: "Login Email Id",
      type: "email",
    },
    {
      name: "communicationEmail",
      label: "Communication Email Id",
      type: "email",
    },
    {
      name: "name",
      label: "Full Name",
      props: { pattern: "^[A-Za-z]+( [A-Za-z]+)*$" },
    },
    {
      name: "city",
      label: "City",
      props: { pattern: "^[A-Za-z]+( [A-Za-z]+)*$" },
    },
    { name: "country", label: "Country", type: "country" },
    {
      name: "state",
      label: "State (India)",
      type: "indiastate",
      dynamic: [["hide", [":country", "!=", "India"]]],
    },
    {
      name: "type",
      label: "Trainer Type",
      props: { required: true },
      type: "multiselect",
      options: [
        { name: "C", label: "Cancer" },
        { name: "MH", label: "Mental Health" },
        { name: "O", label: "Other" },
      ],
    },
    {
      name: "x2",
      type: "statichtml",
      label: "<br/><br/>",
    },
    {
      name: "inactive",
      label: "Deactivated",
      type: "toggle",
    },
  ],
  collection: "CareTrainers",

  primaryKey: "email",

  defaults: {},
};

const trainersCollection = trainersConfig.collection;

export const trainersSelectors = () =>
  commonSelectors(trainersConfig.collection);

export const postprocessTrainers = (r) => {
  const ret = { ...r };
  ret[trainersConfig.primaryKey] = r[trainersConfig.primaryKey]
    .toLowerCase()
    .trim();
  ret.inactive = r.inactive === undefined ? false : r.inactive;
  return ret;
};
export const validateTrainers = () => "";

export const queryTrainers = () => ({
  collection: trainersCollection,
  orderBy: "name",
});
